module.exports = __webpack_public_path__ + "img/tuya2.18f53283.png";